import { ActionBrick, registerBrick, Config, ErrorFlow } from 'olympe';
import { httpRequest } from '@olympeio/core';

export default class MatomoRequest extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} url
     * @param {function()} forwardEvent
     * @param {function(*)} setResults
     * @param {function(ErrorFlow | Error)} setErrorFlow
     */
    update($, [url], [forwardEvent, setResults, setErrorFlow]) {
        // get domain and api key from oConfig file
        const hostProxy = Config.getParameter('matomo.hostProxy'); // domain name will be the app with the proxy
        const auth = Config.getParameter('matomo.api_key');

        // get request to proxy, send api_key in header
        httpRequest('GET', hostProxy + '?module=API&format=json&token_auth=' + auth + '&' + url, {})
            .then(response => {
                if (!response.ok) {
                    setErrorFlow(ErrorFlow.create(`Network response was not ok: ${response.error}`, response.code));
                    return
                }
                return response.json().then((data) => {
                    setResults(data);
                    forwardEvent();
                });
            })
            .catch(error => {
                setErrorFlow(error)
            });
    }
}

registerBrick('018cafcc6398bcd9fe10', MatomoRequest);
